const getTokenLogoURL = (address: string) => {
  return `http://app.fbomb.finance/images/tokens/${address}.png`
}

export default getTokenLogoURL
